import styled from 'styled-components'
import { motion } from 'framer-motion'

// colours
import * as colors from '../../styles/abstracts/_variables.styles'
import * as breakpoints from '../../styles/abstracts/_breakpoints'

const {
  xxSmallDevices,
  xxSmallDevicesLandscape,
  extraSmallDevices,
  extraSmallDevicesLandscape,
  mediumDevices,
  mediumDevicesLandscape,
  largeDevices,
  extraLargeDevices,
  xxLargeDevices,
} = breakpoints

export const Div = styled(motion.div)`
  margin: auto auto;
  padding: 2rem 0rem;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
    padding: 1rem 0rem;
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
    padding: 2rem 2rem 2rem 2rem;
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const ContactH1 = styled(motion.h1)`
  font-weight: 400;
  font-size: 5rem;
  text-align: right;
  padding: 2rem 0rem 0rem 0rem;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const FormDiv = styled(motion.div)`
  margin: auto auto;
  padding: 2rem 1rem;
  align-items: center;
  height: auto;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
    padding: 1rem 1rem;
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
    padding: 2rem 1rem;
    margin: auto 2rem;
    width: 100%;
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
    height: 50vh;
    
`

export const GridContainer = styled(motion.div)`
  padding: 0rem 0rem;
  margin: auto auto;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const FlexItem = styled(motion.div)`
  margin: 2rem 2rem 2rem 2rem;
  width: 100%;
  min-width: 30rem;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const Img = styled(motion.img)`
  width: 100%;
  height: auto;
  overflow: hidden;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const Video = styled.video`
  padding: 15rem 15rem;
  margin: auto auto;
  width: 100%;
  height: 80%;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const H1 = styled(motion.h1)`
  letter-spacing: 1rem;
  margin: 0rem 0rem;
  padding: 0rem 0rem;
  font-size: 6rem;
  font-weight: 900;

  ${
    '' /* position: absolute;
  top: 10rem;
  left: 5rem; */
  }

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const StyleP = styled(motion.p)`
  letter-spacing: 0.4rem;
  margin: auto auto;
  padding: 0rem 0rem 2rem 0rem;
  font-size: 1.25rem;
  font-weight: 200;
  text-align: center;
  line-height: 1.2;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
    padding:
      0rem 10rem,
      0rem 10rem;
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
    font-size: 1.25rem;
    padding: 1rem 0rem 2rem 0rem;
  }
  @media ${xxLargeDevices} {
    font-size: 1.5rem;
    padding: 1rem 0rem 2rem 0rem;
  }
`

export const ItemP = styled(motion.p)`
  letter-spacing: 0.2rem;
  margin: 0rem 0rem;
  padding: 3rem 3rem 3rem 3rem;
  color: ${(props) => props.color};
  font-size: 2.5rem;
  font-weight: 400;
  position: absolute;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const DivButton = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem 1rem;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`
